"use client";

import { useEffect } from "react";
import { useUIActions } from "@/lib/context/UIProvider";

/**
 * Keeps the global page-loading lock held while `loading` is true.
 * Used to disable language switching during route/data loads.
 *
 * Subscribes to UI *actions* only — reading the full context here would
 * re-render every screen on each loading tick.
 */
export function useReportPageLoading(loading: boolean) {
  const { beginPageLoading, endPageLoading } = useUIActions();

  useEffect(() => {
    if (!loading) return;
    beginPageLoading();
    return () => endPageLoading();
  }, [loading, beginPageLoading, endPageLoading]);
}
